import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

import { ChosePlanComponent } from './chose-plan.component';

import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', component: ChosePlanComponent }
        ]
    }
];

@NgModule({
  declarations: [ChosePlanComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forChild(routes)
    
  ],
  exports: [RouterModule],
  providers:[]
})
export class ChosePlanModule { }
